import { render, staticRenderFns } from "./SQuesTwentyThree.vue?vue&type=template&id=3053a8f1&"
import script from "./SQuesTwentyThree.vue?vue&type=script&lang=js&"
export * from "./SQuesTwentyThree.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports